import './ErrorPage.module.css'

const ErrorPage = (props) => {
    return <h1> Looks like you have an error</h1>
}

export default ErrorPage;